import { filter, map, Observable, BehaviorSubject } from 'rxjs';

interface EventBusEvent<T, D> {
  type: D;
  payload: T;
}

export class EventBus<EventTypes> {
  private readonly eventBus = new BehaviorSubject<EventBusEvent<unknown, EventTypes> | null>(null);

  emit<T>(event: EventBusEvent<T, EventTypes>): void {
    this.eventBus.next(event);
  }

  on$<T>(type: EventTypes): Observable<T> {
    return this.eventBus.asObservable().pipe(
      filter(
        (event): event is EventBusEvent<T, EventTypes> => event !== null && event.type === type
      ),
      map(event => event.payload)
    );
  }
}
